module.exports = __webpack_public_path__ + "static/media/star-half-alt.ce108d83.svg";